import 'quill/dist/quill.snow.css'
import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import ReactQuill from 'react-quill'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {InputText} from '../../../../../../components/UI/Input'
import {useCentral} from '../../../../../../hooks/useCentral'
import {EmailTemplateModel} from '../../../../model/emailtemplate.model'
import {ModuleModel} from '../../../../model/module.model'
import {TableViewModel} from '../../../../model/tableview.model'
import {getModule} from '../../../../services'
import {getEmailTemplateById, getTablesViews} from '../../../../services/emailtemplate.service'
import {TITLE_FORM_EMAIL_TEMPLATE} from '../../../../util/Constants'
import {initValues} from '../../../../util/values/email'
import toolbar from '../toolbar/toolbar'
const Index: FC = () => {
  const {
    register,
    formState: {errors},
    setValue,
    watch,
  } = useFormContext()
  const {currentTabItem} = useCentral()
  const [modules, setModules] = useState<ModuleModel[] | any>([])
  const [tablesviews, setTablesViews] = useState<TableViewModel[] | any>([])
  const [text, setText] = useState<'' | any>()
  const enviocustomizado = [
    {value: 'SI', label: 'SI'},
    {value: 'NO', label: 'NO'},
  ]
  const handleChange = (html = '') => {
    if (html !== '<p><br></p>') {
      setText(html)
      setValue('mensaje', html)
    } else {
      setText('')
      setValue('mensaje', '')
    }
  }

  const handleChangeTable = (Id: any) => {
    setValue('idColumna', Id.idCampo)
    setValue('tabla', Id.value)
  }

  const module = {
    toolbar: toolbar,
  }

  useEffect(() => {
    getModules()
    getTables()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getEmailTemplateByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const getModules = async () => {
    try {
      const response = await getModule({}, 1)
      const data = response.data.data
      const mappedSites: ModuleModel[] = data.map((item) => ({
        value: item.id || '',
        label: item.nombre || '',
      }))
      setModules(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de modulos:', error)
    }
  }

  const getTables = async () => {
    try {
      const response = await getTablesViews()
      const data = response.data
      const mappedSites: TableViewModel[] = data.map((item) => ({
        value: item.nombre || '',
        label: item.nombre || '',
        idCampo: item.idCampo || '',
      }))
      setTablesViews(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de tablas:', error)
    }
  }

  const getEmailTemplateByIdValues = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 50))
      const response = await getEmailTemplateById(currentTabItem.idToEdit)
      const data = response.data.data
      type EmailTemplateModelKeys = keyof EmailTemplateModel

      for (const fieldName in initValues) {
        if (initValues.hasOwnProperty(fieldName)) {
          if (data.hasOwnProperty(fieldName)) {
            if (data[fieldName as EmailTemplateModelKeys]) {
              if (fieldName === 'mensaje') {
                try {
                  const decodedContent = decodeURIComponent(
                    escape(atob(data[fieldName as EmailTemplateModelKeys] as string)),
                  )
                  setText(decodedContent)
                  setValue(fieldName, decodedContent)
                } catch (error) {
                  const decodedContent = decodeURIComponent(
                    (data[fieldName as EmailTemplateModelKeys] as string).replace(/\+/g, ' '),
                  )
                  setText(decodedContent)
                  setValue(fieldName, decodedContent)
                }
              } else {
                setValue(fieldName, data[fieldName as EmailTemplateModelKeys])
              }
            } else {
              setValue(fieldName, '')
            }
          }
        }
      }
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }

  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_EMAIL_TEMPLATE}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Modulos' name='aplicacionId' data={modules} required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Envío Customizado'
            name='envioCustomizado'
            data={enviocustomizado}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-6'>
          <label className='required'>Nombre email</label>
          <InputText name='nombre' textPlaceholder='' register={register} errors={errors} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>De</label>
          <InputText name='de' textPlaceholder='' register={register} errors={errors} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Para</label>
          <InputText name='para' textPlaceholder='' register={register} errors={errors} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>CC</label>
          <InputText name='conCopia' textPlaceholder='' register={register} errors={errors} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>CCO</label>
          <InputText name='conCopiaOculta' textPlaceholder='' register={register} errors={errors} />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-lg-6'>
          <label className='required'>Mensaje</label>
          <ReactQuill theme='snow' value={text} onChange={handleChange} modules={module} />
          <InputText name='mensaje' register={register} errors={errors} type='hidden' />
        </div>
        <div className='col-sm-12 col-lg-6'>
          <div className='row'>
            <div className='col-lg-12'>
              <label className='required'>Asunto</label>
              <InputText name='asunto' textPlaceholder='' register={register} errors={errors} />
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tabla'
            name='tabla'
            data={tablesviews}
            onChangeValue={handleChangeTable}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Id Columna</label>
          <InputText
            name='idColumna'
            textPlaceholder=''
            register={register}
            errors={errors}
            disabled={true}
          />
        </div>
        <div className='col-sm-12 col-lg-6'>
          <label>Observaciones</label>
          <InputText name='observaciones' textPlaceholder='' register={register} errors={errors} />
        </div>
      </div>
    </ContentForm>
  )
}

export default Index
